import { ChartPeriodDto, TradingGatewayApiClient } from 'common/api/autogenerated/trading-gateway';

// think about moving this to the common folder
const tradingGatewayApiClient = new TradingGatewayApiClient({
  BASE: '/trading-gateway',
  WITH_CREDENTIALS: true,
});

export const getAssetInfo = (symbol: string) =>
  tradingGatewayApiClient.assets.getV1AssetsInfo(encodeURIComponent(symbol));

export const getAssets = () => tradingGatewayApiClient.assets.getV1Assets(undefined, undefined, 1, 500);

export const getAssetsGroups = () => tradingGatewayApiClient.assets.getV1AssetsGroups();

export const getFavoriteAssets = () => tradingGatewayApiClient.assets.getV1AssetsFavorites();

export const setFavoriteAsset = (symbol: string) =>
  tradingGatewayApiClient.assets.postV1AssetsFavorites(encodeURIComponent(symbol));

export const deleteFavoriteAsset = (symbol: string) =>
  tradingGatewayApiClient.assets.deleteV1AssetsFavorites(encodeURIComponent(symbol));

export const getCandles = (asset: string, candlesCount?: number, to?: string, from?: string, period?: ChartPeriodDto) =>
  tradingGatewayApiClient.assets.getV1AssetsChartHistory(encodeURIComponent(asset), candlesCount, to, from, period);

export const getSpotDailyCandles = (symbol: string[]) =>
  tradingGatewayApiClient.assets.postV1AssetsDailyCandlesSearch({
    assets: symbol,
  });

export const getOrderBookTicks = (symbol: string) =>
  tradingGatewayApiClient.orderBook.getV1OrderBookTicks(encodeURIComponent(symbol));

export const getOrderBook = (symbol: string, tick: string, count?: number) =>
  tradingGatewayApiClient.orderBook.getV1OrderBook(encodeURIComponent(symbol), tick as unknown as number, count);

export const getCoins = () => tradingGatewayApiClient.coins.getV1Coins(undefined, 1, 1000);

export const getSpotCommissions = () => tradingGatewayApiClient.spotTrading.getV1SpotCustomerCommissions();

export const getFavoriteCoins = () => tradingGatewayApiClient.coins.getV1CoinsFavorites();

export const setFavoriteCoin = (symbol: string) => tradingGatewayApiClient.coins.postV1CoinsFavorites(symbol);

export const deleteFavoriteCoin = (symbol: string) => tradingGatewayApiClient.coins.deleteV1CoinsFavorites(symbol);

export const fetchCoinCategories = async () => tradingGatewayApiClient.coins.getV1CoinsCategories(true);

export const getNews = () => tradingGatewayApiClient.resources.getV1ResourcesNews();
